// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"822":"ef6c3c3d","947":"eb19ac30"}[chunkId] + ".chunk.css");